/* eslint no-console:0 */
import "@hotwired/turbo-rails"
import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import "./alpine"
import "./controllers"
import "./refreshers"
//import "./channels"
import ApexCharts from 'apexcharts'
//import "./stylesheets/application.scss"

Rails.start()
Turbo.start()
ActiveStorage.start()
window.ApexCharts = ApexCharts
//import "controllers"
//import "channels"


function smoothScrollTo(element) {
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 1000; // duration of the scroll in milliseconds
    let start = null;

    window.requestAnimationFrame(step);

    function step(timestamp) {
    if (!start) start = timestamp;
    const progress = timestamp - start;
    window.scrollTo(0, easeInOutCubic(progress, startPosition, distance, duration));
    if (progress < duration) window.requestAnimationFrame(step);
    }

    function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
    }
}


window.addEventListener('turbo:load', function(){
    const focusableElementsSelector = 'input[type="text"], textarea';
    document.querySelectorAll(focusableElementsSelector).forEach(element => {
        element.addEventListener('focus', () => {
            if (isTouchDevice()) {
                // Delay to allow keyboard to appear
                setTimeout(() => {
                    scrollToElementIfNeeded(element);
                }, 500); // Adjust timeout as needed
            }
        });
    });

    function isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    
    function scrollToElementIfNeeded(element) {
        if (typeof element.scrollIntoViewIfNeeded === 'function') {
            element.scrollIntoViewIfNeeded(true); // Center align
        } else {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' }); // Fallback
        }
    }
    

    let smoothScrollToElements = document.querySelectorAll('[data-smoothscrollto]');
    if( smoothScrollToElements != null ){
        smoothScrollToElements.forEach(function(smoothScrollToElement){
            smoothScrollToElement.addEventListener('click', function(){
                let scrollToElement = document.querySelector(smoothScrollToElement.dataset.smoothscrollto);
                setTimeout(()=>{smoothScrollTo(scrollToElement);},100);
            });
        });
    }
});

// Images (jpg, jpeg, png) are imported  here.
// This will copy all static images under `frontend/images` to the output
// folder and reference them with the image_pack_tag helper in views
// (e.g <%= image_pack_tag 'hero.png' %>) or the `imagePath` JavaScript helper
// below.


